export default __webpack_public_path__ + "media/images/gallery/18-715acda27deb219df57af2d51f8c070c.jpg";